/**
 * @generated SignedSource<<7488f75df4ce7e5ceebc3899b65aa2d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type recoilProviderHasSettingsQuery$variables = {
  contains: any;
};
export type recoilProviderHasSettingsQuery$data = {
  readonly sys_providers: ReadonlyArray<{
    readonly provider_id: number;
  }>;
};
export type recoilProviderHasSettingsQuery = {
  response: recoilProviderHasSettingsQuery$data;
  variables: recoilProviderHasSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contains"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "limit",
        "value": 1
      },
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_contains",
                "variableName": "contains"
              }
            ],
            "kind": "ObjectValue",
            "name": "ingestion_config"
          },
          {
            "kind": "Literal",
            "name": "is_active",
            "value": {
              "_eq": true
            }
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_providers",
    "kind": "LinkedField",
    "name": "sys_providers",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider_id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "recoilProviderHasSettingsQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "recoilProviderHasSettingsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "25825f84fd822ee0379ff848fb9fe52e",
    "id": null,
    "metadata": {},
    "name": "recoilProviderHasSettingsQuery",
    "operationKind": "query",
    "text": "query recoilProviderHasSettingsQuery(\n  $contains: jsonb!\n) {\n  sys_providers(where: {ingestion_config: {_contains: $contains}, is_active: {_eq: true}}, limit: 1) {\n    provider_id\n  }\n}\n"
  }
};
})();

(node as any).hash = "192abe8fec59f52c213186ff7a4438bc";

export default node;
